interface State {
  cached: boolean;
  statusBarHeight: number;
  navBarHeight: number;
}

const initState: State = {
  cached: false,
  statusBarHeight: 0,
  navBarHeight: 0
};

const common = {
  state: initState,

  reducers: {
    updateState(state: State, payload) {
      return {
        ...state,
        ...payload
      };
    }
  }
};

export default common;
